<template>
    <!--消息统计-->
    <div id="centreLeft1">
        <div class="bg-color-black">
            <div class="d-flex pt-2 pl-2">
                <span style="color:#5cd9e8">
                  <icon name="chart-pie"></icon>
                </span>
                <div class="d-flex">
                    <span class="fs-xl text mx-2">消息统计</span>
                    <dv-decoration-3 style="width:1.25rem;height:.25rem; position:relative;top:-.0375rem;" />
                </div>
            </div>

            <div style="display: grid;grid-template-columns: 6fr 6fr;">
                <div id="chart-pie2" style="width:3rem;height:2.2rem;"></div>
                <div style="margin: 0.2rem auto">
                    <div style="display: grid;grid-template-columns: 6fr 6fr;height:1.1rem;">
                        <div class="border-box">
<!--                            <dv-border-box-7>-->
                                <div class="head">
                                    全部工单
                                </div>
                                <div class="num">
                                    {{repair_data.total}}
                                </div>
<!--                            </dv-border-box-7>-->
                        </div>
                        <div class="border-box">
<!--                            <dv-border-box-7>-->
                                <div class="head">
                                    今日新增
                                </div>
                                <div class="num">
                                    {{repair_data.today}}
                                </div>
<!--                            </dv-border-box-7>-->
                        </div>
                    </div>
                    <div style="display: grid;grid-template-columns: 6fr 6fr;height:1.1rem;margin-top: 0.1rem;">
                        <div class="border-box">
<!--                            <dv-border-box-7>-->
                                <div class="head">
                                    未处理
                                </div>
                                <div class="num">
                                    {{repair_data.repaired}}

                                </div>
<!--                            </dv-border-box-7>-->
                        </div>
                        <div class="border-box">
<!--                            <dv-border-box-7>-->
                                <div class="head">
                                    已处理
                                </div>
                                <div class="num">
                                    {{repair_data.un_repaired}}

                                </div>
<!--                            </dv-border-box-7>-->
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
  import echartMixins from "@/utils/resizeMixins";
  export default {
    data() {
      return {
        chart: null
      };
    },
    mixins: [echartMixins],
    props: {
      chart2_data: {
        type: Object
      },
      repair_data: {
        type: Object
      },
    },
    mounted() {
      this.draw();
    },
    methods: {
      draw() {
        // 基于准备好的dom，初始化echarts实例
        this.chart = this.$echarts.init(document.getElementById("chart-pie2"));
        let option = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            left: 'left',
            data: this.chart2_data.data,
            show: true,
            textStyle: {
              color: '#fff'
            }
          },
          // series: [
          //   {
          //     name: '消息统计',
          //     type: 'pie',
          //     radius: '55%',
          //     center: ['70%', '60%'],
          //     data: this.chart2_data.series,
          //     emphasis: {
          //       itemStyle: {
          //         shadowBlur: 10,
          //         shadowOffsetX: 0,
          //         shadowColor: 'rgba(0, 0, 0, 0.5)'
          //       }
          //     },
          //     label: {
          //       normal: {
          //         position: 'inner',
          //         show : false
          //       }
          //     },
          //   }
          // ]
          series: [
            {
              name: '消息统计',
              type: 'pie',
              radius: ['50%', '70%'],
              center: ['70%', '60%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: 'center'
              },
              labelLine: {
                show: false
              },
              data: this.chart2_data.series
            }
          ]
        };


        this.chart.setOption(option);
      }
    },
    destroyed() {
      window.onresize = null;
    }
  };
</script>


<style lang="scss">
    #centreLeft1 {
        padding: 0.2rem;
        /*height: 5.125rem;*/
        min-width: 3.75rem;
        border-radius: 0.0625rem;
        .bg-color-black {
            /*height: 2.8125rem;*/
            border-radius: 0.125rem;
        }
        .text {
            color: #c3cbde;
        }
        .chart-box {
            margin-top: 0.2rem;
            width: 2.125rem;
            height: 2.125rem;
            .active-ring-name {
                padding-top: 0.125rem;
            }
        }

        .bottom-data {
            .item-box {
                float: right;
                position: relative;
                width: 50%;
                color: #d3d6dd;
                // 金币
                .coin {
                    position: absolute;
                    left: 0.1rem;
                    top: 0.2125rem;
                    font-size: 0.25rem;
                    color: #ffc107;
                }
                .colorYellow {
                    color: yellowgreen;
                }
            }
        }
    }

</style>
